import Select, { Option } from "@albertsons/uds/molecule/Select";
import { Trash } from "lucide-react";
import { TableColumn } from "../../components/Table/CommonTable.types";
import {
  UpdateAccessPayload,
  UserDetail,
  UserState,
  UserRole,
} from "../../types/auth.types";

interface ColumnProps {
  loggedInUserId: string | null;
  updateAccess: (data: UpdateAccessPayload) => void;
  deleteAccess: (id: string) => void;
}

const userRoles = [UserRole.USER, UserRole.DEV, UserRole.QA, UserRole.ADMIN];

export const getUserDetailColumns = ({
  loggedInUserId,
  updateAccess,
  deleteAccess,
}: ColumnProps): TableColumn<UserDetail>[] => [
  {
    id: "email",
    label: "EMAIL",
    value: (row) => row.email || "",
    align: "center",
    width: "300px",
  },
  {
    id: "state",
    label: "State",
    value: (row) => {
      const options = [
        row.state === UserState.REQUESTED ? UserState.REQUESTED : null,
        UserState.APPROVED,
        [UserState.REQUESTED, UserState.DECLINED].includes(row.state)
          ? UserState.DECLINED
          : null,
        [UserState.APPROVED, UserState.REVOKED].includes(row.state)
          ? UserState.REVOKED
          : null,
      ].filter((option) => option !== null);

      return (
        <Select
          className="w-full mt-[2px] border border-[#e5e7eb] text-sm mb-2"
          size="md"
          id={`${row.id}-state-select`}
          value={row.state || ""}
          onChange={(item: any) => {
            updateAccess({
              id: row.id,
              state: item,
              role: row.role,
              comments: "",
            });
          }}
          disabled={row.id === loggedInUserId}
        >
          {options.map((option) => (
            <Option
              key={option}
              item={option}
              disabled={option === row.state}
            />
          ))}
        </Select>
      );
    },
    align: "center",
    width: "150px",
  },
  {
    id: "role",
    label: "Role",
    value: (row) => (
      <Select
        className="w-full mt-[2px] border border-[#e5e7eb] text-sm mb-2"
        size="md"
        id={`${row.id}-role-select`}
        value={row.role || ""}
        onChange={(item: any) => {
          updateAccess({
            id: row.id,
            state: row.state,
            role: item,
            comments: "",
          });
        }}
        disabled={row.id === loggedInUserId}
      >
        {userRoles.map((item) => (
          <Option key={item} item={item} disabled={item === row.role} />
        ))}
      </Select>
    ),
    align: "center",
    width: "150px",
  },
  {
    id: "user_note",
    label: "User note",
    value: (row) => row.user_note || "",
    align: "center",
    minWidth: "250px",
  },
  {
    id: "actions",
    label: "Action",
    sortable: false,
    value: (row) => {
      if (row.id === loggedInUserId) {
        return "";
      }
      return (
        <Trash
          className="cursor-pointer"
          onClick={() => deleteAccess(row.id)}
        />
      );
    },
    align: "center",
    width: "80px",
  },
];
